import React from 'react';
import styled from 'styled-components';

import { PaginationBar } from '../../entity/shared/tabs/Glossary/PaginationBar';
import { ResultWrapper } from '../../search/SearchResultList';
import { useEntityRegistry } from '../../useEntityRegistry';
import { usePagination } from '../../shared/usePagination';
import { EntityType } from '../../../types.generated';
import useListDomains from '../useListDomains';
import { Message } from '../../shared/Message';
import { ComponentSpinner } from '../../shared/ComponentSpinner';

const DomainsWrapper = styled.div`
    padding: 0px;
    overflow: auto;
`;

export default function RootDomains() {
    const entityRegistry = useEntityRegistry();
    const { loading, error, data, sortedDomains } = useListDomains({});

    const { page, pageSize, totalCount, handleChangePage, handleShowSizeChange, getItemsForPage } = usePagination({
        items: sortedDomains || [],
    });

    const paginatedDomains = getItemsForPage(page);

    return (
        <>
            {error && <Message type="error" content="Failed to load domains. An unexpected error occurred." />}
            {!data && loading && <ComponentSpinner />}
            {/* Domains */}
            <DomainsWrapper>
                {paginatedDomains.map((domain) => (
                    <ResultWrapper key={domain.urn} showUpdatedStyles className="pa-3">
                        {entityRegistry.renderSearchResult(EntityType.Domain, {
                            entity: domain,
                            matchedFields: [],
                        })}
                    </ResultWrapper>
                ))}
            </DomainsWrapper>

            {/* Pagination */}
            {sortedDomains && sortedDomains.length > 0 && (
                <PaginationBar
                    loading={loading}
                    pageSize={pageSize}
                    page={page}
                    totalCount={totalCount}
                    onChangePage={handleChangePage}
                    onShowSizeChange={handleShowSizeChange}
                />
            )}
        </>
    );
}
